import { Element } from "@/scripts/extends";

class Main extends Element {}

const main = new Main(document.querySelector("main"));

export default main;
